import React, { useState } from 'react'
import { AppWrap, MotionWrap } from '../../wrapper'
import { images } from '../../constants'
import { BsGithub, BsInstagram, BsLinkedin, AiOutlineMail} from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';
import { motion } from 'framer-motion'



import './Footer.scss'

const Footer = () => {

  const [formData, setFormData] = useState({name: '', email: '', message: ''})
  const [isFormSubmitted, setisFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)


  const { name, email, message} = formData;

  const handleChangeInput = (e) => {

    const { name, value} = e.target;

    setFormData({...formData, [name]: value})

  }

  const handleSubmit = () => {

    const contact = {
      name: name,
      email: email,
      message: message,
    }

    setLoading(true);
  }

  return (
    <>

      
      <h2 className='foot-text foot-head'>Contact & Have A Chat With Me</h2>

      <div className='app__footer-cards'>
        <motion.div className='app__footer-card'
          whileInView={{opacity: 1}}
          whileHover={{scale:1.1}}
          transition={{duration: 0.15, type: 'tween'}}
          
        >
          <img src={images.mail} alt="email" />
          <a href="mailto:jacobmetcalfe99@gmail.com" className='details-text'>jacobmetcalfe99@gmail.com</a>
        </motion.div>

        <motion.div className='app__footer-card'
          whileInView={{opacity: 1}}
          whileHover={{scale:1.1}}
          transition={{duration: 0.15, type: 'tween'}}
        >
          <img src={images.iphone} alt="mobile" />
          <a href='tel: 0421251262' className='details-text'>(+61) 421251262</a>
        </motion.div>
      </div>


    </>

  )
}

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  "app__primarybg"
  )

//export default AppWrap(Footer, "footer")






//old form stuff

{/* <div className='app__footer-form app__flex'>

<div className='app__flex'>
  <input className='p-text' type="text" placeholder='Your Name' name="name" value={name} onChange={handleChangeInput} />
</div>

<div className='app__flex'>
  <input className='p-text' type="email" placeholder='Your Email' name="email" value={email} onChange={handleChangeInput} />
</div>

<div>
  <textarea 
    className='p-text'
    placeholder='Your Message'
    value={message}
    name={message}
    onChange={handleChangeInput}
  />

  <button type="button" className='p-text' onClick={handleSubmit}>{loading ? 'Sending' : 'Send Message'}Send Message</button>
</div>
</div> */}
